import "./navbar.css";
import Sun from "../../img/sun.png";
import Moon from "../../img/moon.png";
import { useContext } from "react";
import { ThemeContext } from "../../context";
import {HashLink as  Link} from "react-router-hash-link";

const Navbar = () => {
  const theme = useContext(ThemeContext);

  const handleClick = () => {
    theme.dispatch({ type: "TOGGLE" });
  };
  return (
    <div>

        <div className="main">        
               <div className="cont">
                   <Link className = "but" to ="#" smooth>Home</Link>
                   <Link className = "but" to ="#about" smooth>About</Link>
                   <Link className = "but" to ="#skills" smooth>Skills</Link>
                   <Link className = "but" to ="#project" smooth>Project</Link>
                   <Link className = "but" to ="#contact" smooth>Contact</Link>
                   <a className = "but" href="https://drive.google.com/file/d/1x9X1zY_SLz3KpAgBczBtZdWhj9ybYgmJ/view?usp=sharing" target="_blank" >Resume</a>
               </div>
      

      <div className="t">

      <img src={Sun} alt="" className="t-icon" />
      <img src={Moon} alt="" className="t-icon" />
        <div
            className={ theme.state.darkMode ? "t-button1" : "t-button2" }
          onClick={handleClick}
          // style={{ left: theme.state.darkMode ? 3 : 25 }}
        > </div>
      </div>
      </div>
       </div> 
  );
};

export default Navbar;